import { render, staticRenderFns } from "./PazientiProgettiViewComponent.vue?vue&type=template&id=1d6a94b9"
import script from "./PazientiProgettiViewComponent.vue?vue&type=script&lang=js"
export * from "./PazientiProgettiViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports